export default __webpack_public_path__ + "static/media/analytics.36b03a55.svg";